/*************************************
 *
 * 数据加载 loading 插件
 * Author:smallsix@66629
 *
 *************************************/

import LoadingComponent from './PageLoading'
const Loading = {}
Loading.install = (Vue) => {
  const ToastConstructor = Vue.extend(LoadingComponent)
  const instance = new ToastConstructor()
  instance.$mount(document.createElement('div'))
  document.body.appendChild(instance.$el)
  Vue.prototype.$loading = {
    show () {
      instance.show = true
    },
    close () {
      instance.show = false
    }
  }
}
export default Loading



// WEBPACK FOOTER //
// ./src/plugins/pageLoading/index.js